import React from 'react';
import { Link } from 'react-router-dom';

const fallbackGuides = [
  { to: '/tabela', index: '01', label: 'Tabela da Escala de Glasgow', text: 'Critérios O, V e M lado a lado para consulta rápida.' },
  { to: '/pediatrica', index: '02', label: 'Glasgow pediátrica', text: 'Adaptações da avaliação em lactentes e crianças.' },
  { to: '/ecg-p', index: '03', label: 'ECG-P e pupilas', text: 'Como a reatividade pupilar complementa o escore clássico.' },
  { to: '/como-avaliar', index: '04', label: 'Como avaliar', text: 'Sequência prática, estímulos e registro dos componentes.' },
];

export default function GuideNavigator({ guides = fallbackGuides }) {
  const normalized = guides.map((guide, index) => ({
    index: guide.index || String(index + 1).padStart(2, '0'),
    ...guide,
  }));

  return (
    <section className="guide-nav" aria-labelledby="guide-nav-title">
      <div className="guide-nav__heading">
        <div>
          <span className="section-kicker">Guias da Escala de Glasgow</span>
          <h2 id="guide-nav-title">Vá direto ao ponto clínico que precisa</h2>
        </div>
        <p>Conteúdo complementar à calculadora, organizado por intenção de uso.</p>
      </div>

      <div className="guide-nav__grid">
        {normalized.map((guide, index) => (
          <Link
            key={guide.to}
            className={`guide-card${index === 0 ? ' guide-card--featured' : ''}`}
            to={guide.to}
          >
            <span className="guide-card__index">{guide.index}</span>
            <strong>{guide.label}</strong>
            <span>{guide.text}</span>
            <em>Consultar →</em>
          </Link>
        ))}
      </div>
    </section>
  );
}
